// Google Ads (codice diretto) + Consent Mode v2 avanzata: tag caricato sempre, cookie solo dopo il consenso.
const GADS_ID = process.env.REACT_APP_GADS_ID;
const GADS_LABEL = process.env.REACT_APP_GADS_CONVERSION_LABEL;
const CONSENT_KEY = "hts_cookie_consent_v1";
const DEDUP_MS = 1500;

export const CONSENT_EVENT = "hts-consent-open";
export const isAdsConfigured = () => Boolean(GADS_ID && GADS_LABEL);

export const getConsent = () => {
  try {
    return localStorage.getItem(CONSENT_KEY);
  } catch (e) {
    return null;
  }
};

const adsConsent = (v) => ({ ad_storage: v, ad_user_data: v, ad_personalization: v });

let loaded = false;
export const initConsent = () => {
  if (loaded || !GADS_ID) return;
  loaded = true;
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() { window.dataLayer.push(arguments); };
  window.gtag("consent", "default", { ...adsConsent("denied"), analytics_storage: "denied", wait_for_update: 500 });
  window.gtag("set", "ads_data_redaction", true);
  window.gtag("set", "url_passthrough", true);
  if (getConsent() === "granted") window.gtag("consent", "update", adsConsent("granted"));
  window.gtag("js", new Date());
  window.gtag("config", GADS_ID);
  if (!document.querySelector('script[src^="https://www.googletagmanager.com/gtag/js"]')) {
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(GADS_ID)}`;
    document.head.appendChild(s);
  }
};

export const setConsent = (value) => {
  try {
    localStorage.setItem(CONSENT_KEY, value);
  } catch (e) { /* no-op */ }
  if (typeof window.gtag === "function") {
    window.gtag("consent", "update", adsConsent(value === "granted" ? "granted" : "denied"));
  }
};

export const openConsentSettings = () => window.dispatchEvent(new Event(CONSENT_EVENT));

let lastSent = 0;
// Unica funzione condivisa per i link verso Telegram (conversione Google Ads sul clic).
export const trackTelegramClick = (source) => {
  const now = Date.now();
  if (now - lastSent < DEDUP_MS) return false;
  if (!isAdsConfigured() || typeof window.gtag !== "function") return false;
  lastSent = now;
  window.gtag("event", "conversion", {
    send_to: `${GADS_ID}/${GADS_LABEL}`,
    transport_type: "beacon",
    event_label: source,
  });
  return true;
};
